// extracted by mini-css-extract-plugin
module.exports = {"instagramWrapper":"mh-z","innerTile":"nh-z","heading":"oh-z","instaTileBtn":"ph-z","disabled":"qh-z","instaTileElement":"rh-z","instagramPic":"sh-z"};